<template>
  <v-col md="3">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6" v-text="$t('Dashboard.headingTasks')"></div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            horizontal
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="View All" to='./tasks'>
              <span v-text="$t('Dashboard.viewAll')"></span>
            </v-btn>

          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="pt-0 pb-3">
          <v-simple-table fixed-header height="290px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left text-button">Issue</th>
                  <!--<th class="text-center text-button">Type</th>-->
                  <th class="text-center text-button">Last Upd</th>
                </tr>
              </thead>
              <tbody v-if="user">
                <tr :style="`background-color:`+ item.BGColor" v-for="item in user.d_charts.Tasks" :key="item.CaseID">
                  <td>
                    <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.Description }}</span>
                    </template>
                    <span>{{ item.SellerUserID }}</span>
                  </v-tooltip>
                  </td>
                  <td class="text-center">
                    <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.LastModifiedDate }}</span>
                    </template>
                    <span>{{ item.StatusDescription }}</span>
                  </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
       showingTasks: "View All",
    };
  },
  computed: {
  ...mapGetters(["user"])
  },
};
</script>
